import { InformationHeader, initialInformationHeader } from "src/app/_models/InformationHeader";
import { Userprofile } from "src/app/_models/Userprofile";

export interface UserProfileState {
  loading: boolean;
  userProfile: Userprofile; //own userprofile
  error: any;
  informationHeader: InformationHeader;
  profile: Userprofile;

  hasAccessToLearner: boolean;
  hasAccessToLearnerLoader: boolean;
  hasAccessToLearnerError: any;
}

export const initializeUserProfileState: UserProfileState = {
  loading: false,
  userProfile: null,
  error: null,
  informationHeader: initialInformationHeader,
  profile: null,

  hasAccessToLearner: null,
  hasAccessToLearnerLoader: false,
  hasAccessToLearnerError: null,
}